// src/components/services/TabBar.jsx
import React from "react";
import { BRAND } from "../../config/brandConfig";

function TabBar({ activeTab, setActiveTab }) {
  const tabs = [
    { id: "individuals", label: "High-Net-Worth Individuals" },
    { id: "business", label: "Business Owners" },
    { id: "institutions", label: "Corporates & Institutions" },
  ];

  return (
    <div
      style={{
        display: "inline-flex",
        padding: 4,
        borderRadius: 999,
        backgroundColor: "rgba(148,163,184,0.2)",
      }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          style={{
            border: "none",
            outline: "none",
            cursor: "pointer",
            padding: "0.45rem 1rem",
            borderRadius: 999,
            fontSize: 13,
            fontWeight: activeTab === tab.id ? 600 : 500,
            backgroundColor: activeTab === tab.id ? "#ffffff" : "transparent",
            color: activeTab === tab.id ? BRAND.accent : "#475569",
            boxShadow:
              activeTab === tab.id ? "0 6px 16px rgba(15,23,42,0.10)" : "none",
            whiteSpace: "nowrap",
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default TabBar;
